import React from 'react';
import { translate } from '../i18n';

const Footer = ({ currentPage, setCurrentPage, pages, usine, certification, language }) => {
  const t = (text) => translate(language, text);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Section Logo */}
          <div className="footer-logo">
            <h3 className="footer-title">PHOSPHOKYM</h3>
            <p className="footer-text">Dicalcium Phosphate · Animal Nutrition</p>
            <p className="footer-text" style={{ fontSize: '13px', marginTop: '10px' }}>
              {t('Certification')} {certification?.nom || 'ISO 22000:2018'}
            </p>
            <div className="cert-badges">
              <div className="cert-badge">ISO 22000</div>
              <div className="cert-badge">{t('QUALITÉ')}</div>
            </div>
          </div>

          {/* Section Produits */}
          <div>
            <h3 className="footer-title">{t('Notre produit')}</h3>
            <div className="footer-links">
              <button 
                onClick={() => setCurrentPage('produits')}
                className="footer-link"
              >
                {t('DCP Granulaire · Feed Grade')} · {t('Big bags')}
              </button>
            </div>
          </div>

          {/* Section Liens */}
          <div>
            <h3 className="footer-title">{t('Navigation')}</h3>
            <div className="footer-links">
              {pages.map(page => (
                <button
                  key={page.id}
                  onClick={() => setCurrentPage(page.id)}
                  className="footer-link"
                >
                  {page.label}
                </button>
              ))}
            </div>
          </div>

          {/* Section Contact */}
          <div>
            <h3 className="footer-title">{t('Contact')}</h3>
            <p className="footer-text">{usine?.adresse || 'Zone Industrielle Nord, BP 1234'}</p>
            <p className="footer-text">{usine?.ville || 'Sfax, Tunisie'}</p>
            <p className="footer-text">{t('Tél:')} {usine?.telephone || '+216 71 234 567'}</p>
            <p className="footer-text">Email: {usine?.email || 'contact@phosphokym.com'}</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PHOSPHOKYM. {t('Tous droits réservés.')}</p>
          <p>
            <button 
              onClick={() => setCurrentPage('contact')}
              className="footer-link"
              style={{ display: 'inline', margin: '0 10px' }}
            >
              {t('Mentions légales')}
            </button>
            | 
            <button 
              onClick={() => setCurrentPage('contact')}
              className="footer-link"
              style={{ display: 'inline', margin: '0 10px' }}
            >
              {t('Politique de confidentialité')}
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;